export enum NoticeStatus {
  // 未发布
  DRAFT = 0,
  // 已发布
  PUBLISHED = 1,
  // 已过期
  EXPIRED = 2
}

export const NoticeStatusTextMap = {
  [NoticeStatus.DRAFT]: '未发布',
  [NoticeStatus.PUBLISHED]: '已发布',
  [NoticeStatus.EXPIRED]: '已过期'
}
